import React from "react";
export var AccountDataSection = function AccountDataSection(_ref) {
    var heading = _ref.heading, children = _ref.children;
    return /*#__PURE__*/ React.createElement("div", {
        className: "mb-6"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "uppercase mb-2"
    }, heading), children);
};
export default AccountDataSection;
